<template>
  <div>
    <div id="publisher"></div>
  </div>
</template>

<script>
import OT from '@opentok/client'

export default {
  name: 'ot-publisher',
  props: {
    session: {
      type: OT.Session,
      required: false
    },
    opts: {
      type: Object,
      required: false
    }
  },
  mounted() {
    this.initializePublisher();
    this.deviceSources();
  },
  watch: {
    isScreenSharing(newValue) {
      if (newValue) {
        this.startScreenSharing();
      } else {
        this.stopScreenSharing();
      }
    }
  },
  methods: {
    initializePublisher() {
      this.publisher = OT.initPublisher(this.$el, this.opts, (err) => {
        if (err) {
          this.$emit('error', err);
        } else {
          this.$emit('publisherCompleted');
        }
      });
      if (this.session && this.session.isConnected()) {
        this.publish();
      }
      if (this.session) {
        this.session.on('sessionConnected', this.publish);
      }
      this.$emit('publisherCreated', this.publisher);
    },
    publish() {
      this.session.publish(this.publisher, (err) => {
        if (err) {
          this.$emit('error', err);
        } else {
          this.$emit('publisherConnected', this.publisher);
        }
      });
    },
    async changeDevice() {
      if (this.opts.audioSource !== this.audioSelect) {
        this.opts.audioSource = this.audioSelect;
        this.reinitializePublisher();
      }

      if (this.opts.videoSource !== this.displaySelect) {
        this.opts.videoSource = this.displaySelect;
        this.reinitializePublisher();
      }
    },
    reinitializePublisher() {
      if (this.session) {
        this.session.unpublish(this.publisher);
      }
      this.publisher.destroy();
      this.initializePublisher();
    },
    async deviceSources() {
      OT.getDevices((err, devices) => {
        if (err) {
          alert('getDevices error ' + err.message);
          return;
        }
        devices.forEach(element => {
          if (element.kind === "videoInput") {
            this.displaySelects.push({ text: element.label, value: element.deviceId });
          }
          if (element.kind === "audioInput") {
            this.audioSelects.push({ text: element.label, value: element.deviceId });
          }
        });
        if (this.displaySelects.length > 0) {
          this.displaySelect = this.displaySelects[0].value;
        }
        if (this.audioSelects.length > 0) {
          this.audioSelect = this.audioSelects[0].value;
        }
      });
    },
    stopScreenSharing() {
      if (this.screenPublisher) {
        this.session.unpublish(this.screenPublisher);
        this.screenPublisher.destroy();
        this.screenPublisher = null;
        if (this.screenAudioContext) {
          this.screenAudioContext.close();
          this.screenAudioContext = null;
        }
        if (this.screenMicStream) {
          this.screenMicStream.getTracks().forEach(t => t.stop());
          this.screenMicStream = null;
        }
        if (this.publisher) {
          this.publisher.publishAudio(true);
        }
        this.$emit('update:isScreenSharing', false);
      }
    },
    async startScreenSharing() {
      OT.checkScreenSharingCapability(async (response) => {
        if (!response.supported || response.extensionRegistered === false) {
          alert('Screen sharing no es soportado en este navegador.');
          return;
        }
        if (response.extensionInstalled === false) {
          alert('Por favor, instala la extensión para compartir pantalla.');
          return;
        }

        try {
          const screenStream = await navigator.mediaDevices.getDisplayMedia({ video: true, audio: true });
          const micStream = await navigator.mediaDevices.getUserMedia({
            audio: this.audioSelect ? { deviceId: { exact: this.audioSelect } } : true
          });
          this.screenMicStream = micStream;

          const screenVideoTrack = screenStream.getVideoTracks()[0];
          const screenAudioTracks = screenStream.getAudioTracks();
          const micAudioTrack = micStream.getAudioTracks()[0];

          let audioSource = micAudioTrack;

          if (screenAudioTracks.length > 0) {
            // Mezclar audio de pantalla + micrófono
            const audioContext = new AudioContext();
            const destination = audioContext.createMediaStreamDestination();
            audioContext.createMediaStreamSource(new MediaStream([screenAudioTracks[0]])).connect(destination);
            audioContext.createMediaStreamSource(new MediaStream([micAudioTrack])).connect(destination);
            audioSource = destination.stream.getAudioTracks()[0];
            this.screenAudioContext = audioContext;
          }

          // Mutear el publisher original para no duplicar el micrófono
          if (this.publisher) {
            this.publisher.publishAudio(false);
          }

          const screenPublisherElement = document.createElement('div');
          this.screenPublisher = OT.initPublisher(screenPublisherElement, {
            videoSource: screenVideoTrack,
            audioSource,
            width: '200px',
            height: '200px'
          }, (error) => {
            if (error) {
              console.log('Error al iniciar screen sharing: ' + error.message);
              if (this.publisher) this.publisher.publishAudio(true);
            } else {
              this.session.publish(this.screenPublisher, (error) => {
                if (error) {
                  console.log('Error al publicar screen sharing: ' + error.message);
                  if (this.publisher) this.publisher.publishAudio(true);
                } else {
                  this.$el.querySelector('#publisher').innerHTML = '';
                  this.$el.querySelector('#publisher').appendChild(screenPublisherElement);
                  this.$emit('update:isScreenSharing', true);
                }
              });

              this.screenPublisher.on('mediaStopped', () => {
                this.stopScreenSharing();
              });

              screenVideoTrack.addEventListener('ended', () => {
                if (this.screenPublisher) this.stopScreenSharing();
              });
            }
          });
        } catch (error) {
          console.log('Error al iniciar screen sharing: ' + error.message);
        }
      });
    },
  },
  data() {
    return {
      publisher: null,
      screenPublisher: null,
      screenAudioContext: null,
      screenMicStream: null,
      audioSelects: [],
      audioSelect: null,
      displaySelects: [],
      displaySelect: null
    }
  }
}
</script>
